import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { ToastController } from 'ionic-angular';

@Injectable()
export class ToastServiceProvider {
  public isOpen: boolean = false;

  constructor(private toastCtrl: ToastController) {}

  public show(message, position = 'bottom', duration = 3000, onDismiss = null) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: position,
      cssClass: 'custom-toast'
    });

    if (onDismiss) {
      toast.onDidDismiss(onDismiss);
    }

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/toast-service/toast-service.ts